import { getCookie, setCookie } from 'cookies-next/client'

const checkAndSetFbcCookie = (fbclid: string): void => {
  if (getCookie('_fbc')?.split('.').at(-1) !== fbclid) {
    setCookie('_fbc', `fb.1.${Date.now()}.${fbclid}`, {
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
      maxAge: 60 * 60 * 24 * 90, // 90 days — Facebook's convention
      secure: true,
      sameSite: 'lax',
    })
  }
}

export default checkAndSetFbcCookie
